export type MetaSearchLifecycleState = {
  activeRequestId: number
  claimedRequestIds: Set<number>
}

export const createMetaSearchLifecycleState = (): MetaSearchLifecycleState => ({
  activeRequestId: 0,
  claimedRequestIds: new Set<number>(),
})

export const normalizeCompletedMetaSearchQuery = (
  value: unknown
): string | undefined => {
  if (typeof value !== "string") return undefined
  const normalized = value.trim().replace(/\s+/g, " ")
  return normalized.length >= 2 && normalized.length <= 100
    ? normalized
    : undefined
}

export const beginMetaSearchRequest = (
  state: MetaSearchLifecycleState
): number => {
  state.activeRequestId += 1
  return state.activeRequestId
}

export const claimCompletedMetaSearch = ({
  state,
  requestId,
  query,
  succeeded,
}: {
  state: MetaSearchLifecycleState
  requestId: number
  query: unknown
  succeeded: boolean
}): string | undefined => {
  const normalizedQuery = normalizeCompletedMetaSearchQuery(query)
  if (
    !succeeded ||
    !normalizedQuery ||
    requestId !== state.activeRequestId ||
    state.claimedRequestIds.has(requestId)
  ) {
    return undefined
  }
  state.claimedRequestIds.add(requestId)
  return normalizedQuery
}
